import { render, staticRenderFns } from "./EditGoodsUnit.vue?vue&type=template&id=4654943c&scoped=true"
import script from "./EditGoodsUnit.vue?vue&type=script&lang=js"
export * from "./EditGoodsUnit.vue?vue&type=script&lang=js"
import style0 from "./EditGoodsUnit.vue?vue&type=style&index=0&id=4654943c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4654943c",
  null
  
)

export default component.exports